import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { useParams, Link } from 'react-router-dom';

import { FormattedMessage } from 'react-intl';
import { OlimpicContextProvider } from '@/pages/olimpic/context';

import { REQUEST_SAVE_OLIMPIC_RESULT } from '@/modules/Olimpic';
import { Box, Flex } from '@/components/UIKit/Grid';
import { useSnackbarListener } from 'sama_global/utils/hooks/snackbar';
import { settings } from 'sama_global/modules/olimpic';
import StyledButton from 'sama_global/components/StyledButton';
import Centrify from 'sama_global/components/Centrify';
import { cleaRequest } from '@/modules/Requests';
import StyledRunExam from './StyledRunExam';

const OlimpicRun = ({ olimpic, requests, clear }) => {
  const { mode } = useParams();

  useSnackbarListener(requests[REQUEST_SAVE_OLIMPIC_RESULT]?.errorMessage);
  useSnackbarListener(
    requests[REQUEST_SAVE_OLIMPIC_RESULT]?.success && 'SAVED',
    'success'
  );

  useEffect(() => {
    return () => {
      clear(REQUEST_SAVE_OLIMPIC_RESULT);
    };
  }, []);

  const { participant, _id: id, official_mode: officialMode } = olimpic;

  return olimpic.participant?.result == null ? (
    <Box m={4} style={{ borderRadius: 10, backgroundColor: 'white' }}>
      <OlimpicContextProvider>
        <div style={{ padding: 15, textAlign: 'center', fontSize: '2rem' }}>
          PAMA Global Abacus & Mental Arithmetic Competition
        </div>
        <StyledRunExam
          id={id}
          view={mode}
          settings={settings.find(item => item.name === participant?.category)}
          isOfficialMode={officialMode === 1}
          smgl
        />
      </OlimpicContextProvider>
    </Box>
  ) : (
    <Centrify>
      <Flex m="auto" p={10} flexDirection="column" aligntItems="center">
        <Box mb={6}>
          <FormattedMessage id="OLIMPIC_COMPLETED" defaultMessage="" />
        </Box>
        <StyledButton component={Link} to="/olimpic/about" variant="contained">
          <FormattedMessage id="OLIMPIC_TITLE" defaultMessage="" />
        </StyledButton>
      </Flex>
    </Centrify>
  );
};

OlimpicRun.propTypes = {
  olimpic: PropTypes.object.isRequired,
  requests: PropTypes.object.isRequired,
  clear: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  requests: state.requests,
  olimpic: state.olimpic.sama || {},
});

const mapDispatchToProps = dispatch => ({
  clear(request) {
    dispatch(cleaRequest(request));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(OlimpicRun);
